import React, { useState, useEffect } from 'react'
import { Col, Panel, Row, Modal, Button, Icon, Message, IconButton, Uploader, Grid } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../../utils/loading'
import AuditReportSummarySearchForm from './AuditReportSummarySearchForm'
import AuditReportSummaryTable from './AuditReportSummaryTable'
import notification from '../../../utils/notification'
import { DEFAULT_ERR_MSG, DELETE_SUCCESS_MSG, SAVE_SUCCESS_MSG } from '../../../constants/msgText'
import { sessionSetItemObj, sessionSetItemStr } from '../../../utils/sessionHelpers'
import { useHistory } from 'react-router-dom'
import { downloadFile, previewFile } from '../../../utils/fileUtil'
import classNames from 'classnames'
import AppContext from '../../../context/AppContext'
import pathname from '../../../constants/pathname'
import {
  deleteProjectImportedData,
  downloadAuditIAp10,
  downloadAuditIAp10word,
  downloadAuditIAp12Pdf,
  onSavefileIAp12,
  processFileImport,
  searchAuditReportSummary,
} from '../../../redux/actions/auditReportSummary'
import { cloneDeep, isEmpty } from 'lodash-es'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import ViewButton from '../../../components/buttons/viewButton/ViewButton'
import ConfirmWidget from '../../confirm/ConfirmWidget'

export default function AuditReportSummaryWidget(props) {
  const { theme } = React.useContext(AppContext)
  const { year, status } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isShowModalUpfile, setIsShowModalUpfile] = useState(false)
  const [isShowModal, setIsShowModal] = useState(false)
  const [displayLength, setDisplayLength] = useState(25)
  const [searchRequest, setSearchRequest] = useState({})
  const [isFileImport, setIsFileImport] = useState(true)
  const [dataImportFile, setDataImportFile] = useState()
  const [deleteId, setDeleteId] = useState()

  const [isRefash, setIsRefash] = useState(false)

  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false)

  let history = useHistory()

  const onSearch = (request) => {
    // console.log('testOnSearch', pageNum, pageSize, request)
    handleSearch(1, displayLength, request)
  }

  const handleSearch = async (pageNum, pageSize, request) => {
    setIsLoading(true)
    startLoading()
    try {
      // console.log('handleSearch', pageNum, pageSize, request)

      setDisplayLength(pageSize)
      setSearchRequest(request)

      const response = await searchAuditReportSummary(pageNum, pageSize, request)

      if (response) {
        let _schema = cloneDeep(formSchema)
        _schema.result = response.model
        setFormSchema(_schema)
        onRefash()
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
      doneLoading()
      setIsLoading(false)
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const onReload = (pagenumber, pagesize) => {
    handleSearch(pagenumber, pagesize, searchRequest)
  }

  const handleImportResults = (xtype) => {
    // console.log('gggooo')
    history.push(`${pathname.audit.AuditFileImport}?type=${xtype}`)
    // setIsShowModalUpfile(true)
    // setIsFileImport(true)
  }

  const handleSelect = (data) => {
    // console.log('data', data)
    if (formSchema?.auditRole?.isCoordinator || formSchema?.auditRole?.isUser) {
      sessionStorage.setItem('projectId', data.projectVersionId)

      history.push(`${pathname.audit.FollowAuditIssues}`)
    } else {
      sessionSetItemObj('auditInfo', data)

      history.push(`${pathname.audit.ReportsAudit}`)

      // const xurl = `${process.env.REACT_APP_SERVER_URL}${pathname.audit.ReportsAudit}`

      // const link = document.createElement('a')
      // // link.target = '_blank'
      // link.rel = 'opener'
      // link.href = xurl
      // link.setAttribute('visibility', 'hidden')
      // document.body.appendChild(link)
      // link.click()
      // link.remove()
    }
  }

  const handleOnShow = (data) => {
    // console.log('data => ', data)
    sessionSetItemObj('auditInfo', data)
    sessionSetItemStr('directorAuditViewMode', 'isViewMode')

    history.push(`${pathname.audit.FundManagerAuditIssues}`)

    // const xurl = `${process.env.REACT_APP_SERVER_URL}${pathname.audit.FundManagerAuditIssues}`

    // const link = document.createElement('a')
    // // link.target = '_blank'
    // link.rel = 'opener'
    // link.href = xurl
    // link.setAttribute('visibility', 'hidden')
    // document.body.appendChild(link)
    // link.click()
    // link.remove()

    // history.push({
    //   pathname: pathname.audit.FundManagerAuditIssues,
    // })
  }

  const handleExportFile = async (id, projectVersionId) => {
    setIsLoading(true)
    startLoading()
    try {
      const file = await downloadAuditIAp10(id, projectVersionId)

      if (file) {
        downloadFile(file, file.name || `รายงานตรวจสอบภายใน IAp10`)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('handleExportFile error : ', e)
      notification.open('error', {
        title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleOnExport = (data) => {
    const id = data.id
    const projectVersionId = ' '

    handleExportFile(id, projectVersionId)
  }

  const handleSubmitImportFile = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const file = getValues('fileImport')

      // console.log('handleSubmitImportFile ', file)

      const formData = new FormData()
      file &&
        file?.forEach((element) => {
          formData.append(`File`, element.blobFile)
        })

      const response = await processFileImport(formData)
      console.log('response => ', response)
      if (response) {
        setDataImportFile(response.model)
      }
      // if (file) {
      //   downloadFile(file, file.name || `รายงานตรวจสอบภายใน IAp10`)
      // } else {
      //   notification.open('error', {
      //     title: DEFAULT_ERR_MSG,
      //     duration: 5000,
      //   })
      // }
    } catch (e) {
      console.log('handleExportFile error : ', e)
      notification.open('error', {
        title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleExportWordFile = async (data) => {
    // console.log('data => ', data)

    setIsLoading(true)
    startLoading()
    try {
      const file = await downloadAuditIAp10word(data.id)
      // console.log('file', file)
      if (file) {
        downloadFile(file, `แบบสรุปรายงานผลการตรวจสอบภายในโครงการรับทุน_IAp10_${data.projectCode}`)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('handleExportFile error : ', e)
      notification.open('error', {
        title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleSaveFileIpa12 = async (file, id) => {
    console.log('handleSaveFileIpa12 => ', file, id)

    // return true

    setIsLoading(true)
    startLoading()
    try {
      const formData = new FormData()
      formData.append('Id', id)

      file &&
        file?.forEach((element) => {
          formData.append('FilePath', element.blobFile)
        })

      const response = await onSavefileIAp12(formData)

      // console.log('response => ', response)

      if (response.success) {
        onReload(1, displayLength)
        // handleSearch(1, 25, {})
        // location.reload()
        setIsLoading(false)
        doneLoading()
        return true
      }
    } catch (e) {
      console.log('handleExportFile error : ', e)
      notification.open('error', {
        title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()

    return false
  }

  const handleExportFileIAp12 = async (data, type) => {
    // console.log('data => ', data.filePathIAp12)

    setIsLoading(true)
    startLoading()
    try {
      const file = await downloadAuditIAp12Pdf(data.filePathIAp12)
      // console.log('file', file)
      if (file) {
        if (type == 'view') {
          previewFile(file, `IAp12_${data.projectCode}`)
        } else {
          downloadFile(file, `IAp12_${data.projectCode}`)
        }
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('handleExportFileIAp12 error : ', e)
      notification.open('error', {
        title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const onRefash = () => {
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
    }, 50)
  }

  const handleDelete = (data) => {
    setDeleteId(data.id)
    setIsShowConfirmDelete(true)
  }

  const handleCallDeleteService = async (deleteId) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await deleteProjectImportedData(deleteId)

      if (response?.success) {
        notification.open('success', {
          title: DELETE_SUCCESS_MSG,
          duration: 5000,
        })
        onReload(1, displayLength)
      } else {
        notification.open('error', {
          title: response?.errorMessage || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
      doneLoading()
      setIsLoading(false)
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  return (
    <>
      <Panel shaded collapsible defaultExpanded header={''} bordered>
        {isLoading && <OverlayLoader />}

        {formSchema?.searchForm && (
          <div style={{ marginTop: 0 }}>
            <AuditReportSummarySearchForm
              schema={formSchema.searchForm}
              onSearch={onSearch}
              loading={isLoading}
              year={year}
              status={status}
            />
          </div>
        )}

        {!isRefash && (
          <>
            {formSchema?.auditRole?.isInternalAuditor && (
              <Row style={{ marginTop: 20, textAlign: 'end' }}>
                <ViewButton
                  icon="file-upload"
                  onClick={(e) => handleImportResults('imp01')}
                  children="นำเข้าโครงการสุ่มตรวจ"
                />

                <ViewButton
                  icon="file-upload"
                  onClick={(e) => handleImportResults('imp02')}
                  children="นำเข้าข้อมูลโครงการหลังแต่งตั้งผู้ตรวจสอบ"
                />

                <ViewButton
                  icon="file-upload"
                  onClick={(e) => handleImportResults('imp03')}
                  children="นำเข้าข้อมูลเกรด"
                />
              </Row>
            )}

            {formSchema?.result && (
              <AuditReportSummaryTable
                schema={formSchema}
                loading={isLoading}
                onReload={onReload}
                // page={page}
                // displayLength={displayLength}
                onSelect={handleSelect}
                onExport={handleOnExport}
                onShow={handleOnShow}
                pagination
                onExportWordFile={handleExportWordFile}
                onSaveFiles={handleSaveFileIpa12}
                onExportFileIAp12={handleExportFileIAp12}
                onDelete={handleDelete}
              />
            )}
          </>
        )}
      </Panel>

      {/* Modal เพิ่มรายละเอียด */}
      <Modal
        size="lg"
        show={isShowModalUpfile}
        onHide={(e) => {
          setIsShowModalUpfile(false)
        }}
      >
        <Modal.Header>
          <Modal.Title>{'แนบไฟล์'}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '1000px !important' }}>
          <Panel>
            <>
              <Row style={{ marginTop: 10 }}>
                <Col lg={24} md={24} sm={24} xs={24}>
                  <Controller
                    name={`fileImport`}
                    control={control}
                    defaultValue={''}
                    render={(props) => {
                      return (
                        <Uploader
                          draggable
                          accept={'.xlsx'}
                          autoUpload={false}
                          multiple={false}
                          fileList={props.value || []}
                          onChange={(fileList) => {
                            if (isEmpty(fileList)) {
                              props.onChange(undefined)
                            } else {
                              // props.onChange(fileList)

                              setIsFileImport(false)
                              let files = []
                              files.push(fileList[fileList.length - 1])
                              props.onChange(files)
                            }
                          }}
                        >
                          <div>
                            <div
                              style={{ lineHeight: '50px' }}
                              className={classNames('uploader', `${theme[0]}-background`)}
                            >
                              <Icon size="4x" icon="upload2" />
                              <small className="uploder__text">
                                <p style={{ wordBreak: 'break-word' }}>
                                  คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                                </p>
                              </small>
                            </div>
                          </div>
                        </Uploader>
                      )
                    }}
                  />
                </Col>
              </Row>

              {dataImportFile && (
                <Row style={{ marginTop: 30 }}>
                  <Col lg={24} md={24} sm={24} xs={24}></Col>
                </Row>
              )}
            </>
          </Panel>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleSubmitImportFile} disabled={isFileImport} appearance="primary">
            ดำเนินการ
          </Button>

          <Button
            onClick={(e) => {
              setIsShowModalUpfile(false)
              setIsFileImport(true)
            }}
            color="blue"
            appearance="primary"
          >
            ยกเลิก
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        size="sm"
        show={isShowModal}
        onHide={(e) => {
          setIsShowModal(false)
        }}
      >
        <Modal.Header>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '1000px !important' }}>
          <Panel>
            <>ทุกโครงที่เลือกไว้จะถูกส่งให้ นักวิชาการสำนักเพื่อบันทึกติดตามผลการตรวจสอบ</>
          </Panel>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={(e) => {
              setIsShowModal(false)
            }}
            appearance="primary"
          >
            ตกลง
          </Button>

          <Button
            onClick={(e) => {
              setIsShowModal(false)
            }}
            color="blue"
            appearance="primary"
          >
            ยกเลิก
          </Button>
        </Modal.Footer>
      </Modal>

      <ConfirmWidget
        title={`ยืนยันการลบรายการ`}
        show={isShowConfirmDelete}
        detail={`ยืนยันการลบ`}
        onCancle={() => {
          setIsShowConfirmDelete(false)
          setDeleteId()
        }}
        onConfirm={() => {
          handleCallDeleteService(deleteId)
          setIsShowConfirmDelete(false)
        }}
      />
    </>
  )
}
